module.exports = __webpack_public_path__ + "img/showcase.72049cd3.png";